/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EstimatedBasicCostDtoPage } from '../../models/estimated-basic-cost-dto-page';

export interface ListEstimatedBasicCosts$Params {
  projectId?: string | null;
  budgetVersionIds?: Array<string>;
  costTypeIds?: Array<string>;
  wpIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'repetitions' | '-repetitions' | 'unit' | '-unit' | 'frequency' | '-frequency' | 'outflowDate' | '-outflowDate' | 'id' | '-id' | 'from' | '-from' | 'to' | '-to' | 'total' | '-total' | 'project' | '-project' | 'budget' | '-budget' | 'budgetVersionId' | '-budgetVersionId' | 'budgetName' | '-budgetName' | 'costType' | '-costType' | 'costTypeName' | '-costTypeName' | 'workPackage' | '-workPackage' | 'workPackageName' | '-workPackageName' | 'comment' | '-comment' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'consumption' | '-consumption' | 'consumptionPerc' | '-consumptionPerc'>;
}

export function listEstimatedBasicCosts(http: HttpClient, rootUrl: string, params?: ListEstimatedBasicCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedBasicCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEstimatedBasicCosts.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('budgetVersionIds', params.budgetVersionIds, {});
    rb.query('costTypeIds', params.costTypeIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EstimatedBasicCostDtoPage>;
    })
  );
}

listEstimatedBasicCosts.PATH = '/v0/estimatedBasicCost';
